import { render, staticRenderFns } from "./AgencyShoppingEdit.vue?vue&type=template&id=ed63b7d4&scoped=true"
import script from "./AgencyShoppingEdit.vue?vue&type=script&lang=js"
export * from "./AgencyShoppingEdit.vue?vue&type=script&lang=js"
import style0 from "./AgencyShoppingEdit.vue?vue&type=style&index=0&id=ed63b7d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed63b7d4",
  null
  
)

export default component.exports